var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteFox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#002069"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1623_41982)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.5581 39.1031C69.0547 39.2462 72.5001 44.8339 73.3722 45.5266C76.1489 41.2778 80.3177 36.6033 86.004 38.3911C81.972 41.924 80.2239 46.8848 77.6271 51.4045C77.5919 52.0856 82.8402 58.4124 83.5519 59.7435C83.6849 59.9912 83.9821 60.5291 83.4776 60.5291H79.387C79.0155 60.5291 75.6913 55.1077 75.4215 55.2935C70.2084 66.0742 61.0181 73.0511 48.4254 70.4546C47.0488 70.1721 41.2648 68.4579 40.7721 67.3125C40.6391 66.9023 41.1397 66.8094 41.4095 66.8017C42.4302 66.7746 43.7208 67.1654 44.7337 67.2041C53.1887 67.5214 60.3415 63.9846 65.5507 57.5456C66.3133 56.6014 71.147 49.6206 71.0414 49.0209L64.1037 39.1031C65.273 39.3159 67.553 38.8128 68.5542 39.1031H68.5581Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9187 49.5044C62.9187 55.8506 57.7213 60.9933 51.3076 60.9933C44.8939 60.9933 39.6965 55.8506 39.6965 49.5044C39.6965 43.1583 44.8939 38.0117 51.3076 38.0117C57.7213 38.0117 62.9187 43.1544 62.9187 49.5006V49.5044ZM58.6872 49.458C58.6872 45.4298 55.3865 42.1638 51.3154 42.1638C47.2443 42.1638 43.9436 45.4298 43.9436 49.458C43.9436 53.4863 47.2443 56.7522 51.3154 56.7522C55.3865 56.7522 58.6872 53.4863 58.6872 49.458Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4349 38.3906V42.4382H29.5755C29.5481 42.4382 29.2157 42.771 29.2157 42.7942V47.0779C29.2157 47.105 29.552 47.4339 29.5755 47.4339H36.1925V51.4815H29.2157V60.5286H25.4848C25.4574 60.5286 25.125 60.1959 25.125 60.1726V38.3906H36.4349Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7188 56.28C21.8087 56.427 21.8087 57.3132 21.7266 57.4138C21.6014 57.5647 18.3868 58.0987 17.9019 58.2728C17.894 58.5979 21.5545 59.1087 21.7227 59.3757C21.8126 59.515 21.8087 60.4127 21.7305 60.5095C21.5154 60.7649 16.0873 62.0186 15.2621 62.2005C15.3168 61.887 15.1604 60.8964 15.2738 60.7803C15.4107 60.641 19.1142 60.1689 19.1142 59.9368C17.8158 59.07 14.7889 59.84 15.2621 57.6769L19.3567 56.8411C17.8236 56.1175 14.6598 56.7327 15.266 54.3413C16.0482 54.8366 21.5232 55.9549 21.7266 56.28H21.7188Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7539 49.1016V50.5294H19.1064V52.6732C19.5365 52.7429 21.664 52.5765 21.7539 52.6732C21.8752 52.797 21.7422 54.1011 21.3902 54.1011H15.3794C15.0665 54.1011 14.7771 53.1027 15.2464 52.7816C15.7157 52.4604 17.061 52.7738 17.6633 52.6771V50.5333C17.0024 50.4327 15.7861 50.7384 15.2425 50.4211C15.0548 50.3127 15.1878 49.1054 15.2543 49.1054H21.75L21.7539 49.1016Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2582 38.3906L16.4627 38.3867V40.7704H17.9058V38.6266L18.9695 38.6228L19.1064 40.7704L20.4126 40.7743L20.5534 38.3867L21.754 38.3906V41.9622H15.2582V38.3906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2582 42.4384L16.4627 42.4346V43.6264H21.754V45.0543H16.4627V46.2461H15.2582V42.4384Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.754 46.7217H15.2582V48.1496H21.754V46.7217Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1623_41982"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 33,
    fill: "white",
    transform: "translate(15 38)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteFox);
export default __webpack_public_path__ + "static/media/white_fox.57b1da9faea83cbb52890224d339871a.svg";
export { ForwardRef as ReactComponent };